import { render } from "./ChangeHistoryModal.vue?vue&type=template&id=15543942&scoped=true"
import script from "./ChangeHistoryModal.vue?vue&type=script&lang=js"
export * from "./ChangeHistoryModal.vue?vue&type=script&lang=js"

import "./ChangeHistoryModal.vue?vue&type=style&index=0&id=15543942&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15543942"]])

export default __exports__